<template>
  <div v-if="resolvedLoading" class="scoped-loader-host">
    <PremiumLoader
      :loading="true"
      :current-theme="resolvedTheme"
      :icon="icon"
      :message="message"
      :hint="hint"
    />
  </div>
</template>

<script>
import PremiumLoader from "@/components/Extras/PremiumLoader.vue";

export default {
  components: { PremiumLoader },
  props: {
    overlay: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: undefined,
    },
    currentTheme: {
      type: String,
      default: "",
    },
    icon: {
      type: String,
      default: "mdi-progress-download",
    },
    message: {
      type: String,
      default: "Loading…",
    },
    hint: {
      type: String,
      default: "Please wait a moment",
    },
  },
  computed: {
    resolvedLoading() {
      if (typeof this.loading === "boolean") {
        return this.loading;
      }
      return Boolean(this.overlay);
    },
    resolvedTheme() {
      if (this.currentTheme === "dark" || this.currentTheme === "light") {
        return this.currentTheme;
      }
      const themeName = this.$vuetify?.theme?.global?.name?.value;
      return themeName === "dark" ? "dark" : "light";
    },
  },
};
</script>
